import React from "react";
import Link from "next/link";
import { AiFillCheckCircle, AiOutlineClose } from "react-icons/ai";
import { BsArrowRight } from "react-icons/bs";
import { createUTMQueryParams } from "@utils/signature_owner";

const SignaturePopup = ({ onPopupClose, source = "" }) => {
  return (
    <div className="bg-gray-600/50 w-full h-full fixed z-[1000] left-0 top-0 p-4 flex justify-center items-center">
      <div className="relative rounded-xl bg-violet-500 w-fit mx-auto lg:w-[700px] md:h-[500px] lg:h-[400px] text-white flex flex-col justify-between gap-[50px] md:gap-[10px] p-[50px] px-[20px] lg:px-[50px]">
        <div
          onClick={() => onPopupClose()}
          className="border border-b-none border-violet-300 shadow-xl absolute top-[20px] right-[20px] hover:opacity-90 cursor-pointer grid place-items-center text-white font-bold text-[20px]"
        >
          <AiOutlineClose className="font-bold" />
        </div>
        <div className="flex flex-col gap-[15px]">
          <div className="text-[25px] font-semibold">
            Take Signatures inside Forms & PDFs!
          </div>
          <div className="text-[18px]">Get started for Free</div>
          <div className="">
            {[
              "Integrated Signatures: Add digital signature fields to your forms for easy signing.",
              "PDF Downloads: Download documents with signatures as PDF files.",
              "Super easy and simple to use.",
            ].map((item, index) => {
              return (
                <div key={index} className="flex gap-[10px] text-white">
                  <div className="">
                    <AiFillCheckCircle className="text-[20px]" />
                  </div>
                  {item}
                </div>
              );
            })}
          </div>
        </div>
        <div className="">
          <Link
            target="_blank"
            href={`https://signature.boloforms.com/login?from=${source}${createUTMQueryParams(
              {
                from: source,
              }
            )}`}
            className="flex justify-between items-center gap-4 w-fit bg-white text-violet-600 text-[17px] md:text-[20px] px-[20px] py-[8px] md:px-[40px] md:py-[12px] rounded-full hover:opacity-80"
          >
            Check out BoloForms <BsArrowRight />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignaturePopup;
